import { TradeOrderForm } from './TradeOrderForm';

export default TradeOrderForm;
